export const getBlogBySlug = (slug: string): (() => Promise<unknown | null>) => async () => {
  try {
    const apiUrl = process.env.REACT_APP_GHOST_API_URL;
    const apiKey = process.env.REACT_APP_CONTENT_API_KEY;

    const response = await fetch(
      `${apiUrl}/ghost/api/content/posts/slug/${slug}/?key=${apiKey}&include=authors,tags`,
      {
        headers: {
          "Accept-Version": "v5.69",
        },
      }
    );

    if (response.ok) {
      const blogData = await response.json();
      return blogData.posts?.[0] || null;
    } else {
      console.error("Error: Unable to fetch blog data");
      return null;
    }
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};





